export default "__VITE_PUBLIC_ASSET__0540f700__"